<h1 mat-dialog-title>{{ title }}</h1>
<mat-dialog-content>
  <div class="calendars">
    <app-calendar
      #calendar
      [selectedDates]="selectedDates"
      [minDate]="minDate"
      [maxDate]="maxDate"
      (selectionChanged)="updateTitle($event)"></app-calendar>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button type="button" mat-raised-button (click)="dialogRef.close()">
    {{ 'select-date-range/cancel' | translate }}
  </button>
  <button mat-button type="button" mat-raised-button (click)="clearSelection()">
    {{ 'select-date-range/delete' | translate }}
  </button>
  <button
    mat-button
    type="button"
    mat-raised-button
    color="primary"
    (click)="updateCustomRange(calendar.selectedDates)">
    {{ 'select-date-range/apply' | translate }}
  </button>
</mat-dialog-actions>
